import config from '../config';
import ToggleButton from "./ToggleButton";

let dataManager;
let soundManager;
let apiManager;

class BaseWindow extends Phaser.Scene {
  init () {
    let g = this;
    dataManager = g.sys.game.dataManager;
    soundManager = g.scene.get('SoundManager');
    soundManager.pauseMusic();

    apiManager = g.sys.game.apiManager;
    apiManager.trackGamePause();

    g.scene.pause(dataManager.getSessionItem(config.BASE_SCENE));

    g.scene.bringToTop();

    g.info = { isOpen: false, panel: 'panel.png' };

    // console.log('BaseWindow.init');
  }

  create () {
    let g = this;

    g.events.off('resume');
    g.events.on('resume', (a, data) => {
      // console.log('On Continue Resume');
      soundManager.resumeMusic();
    });

    g.greenBG = g.add.image(config.CENTER_X, config.CENTER_Y, 'overlay-bg');
    g.greenBG.setAlpha(0.75);
    g.startY = config.CENTER_Y - (g.greenBG.height) * 1.5;
    g.greenBG.y = g.startY;
    g.endY = config.CENTER_Y + (g.greenBG.height) * 1.5;

    g.panel = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'common', g.info.panel);

    // add play button from the sprite sheet first frame
    // g.playButton = g.add.sprite(config.CENTER_X, 720, 'common', 'play-button.png');
    g.playButton = g.add.sprite(config.CENTER_X, 720, 'ui-animation');
    g.playButton.play('play-btn');
    g.playButton.setInteractive();
    g.playButton.on('pointerdown', g.playButtonClicked, g, true);

    g.musicButton = new ToggleButton({
      scene: this,
      id: 'music-button',
      texture: 'common',
      isOn: soundManager.isMusicOn(),
      x: config.CENTER_X - 135,
      y: 666,
      onClick: this.toggleMusic,
      onClickScope: this
    });

    g.sfxButton = new ToggleButton({
      scene: this,
      id: 'sfx-button',
      texture: 'common',
      isOn: soundManager.isSoundsOn(),
      x: config.CENTER_X + 135,
      y: 666,
      onClick: this.toggleSounds,
      onClickScope: this
    });

    g.versionText = g.add.bitmapText(config.CENTER_X - 140, 796, 'ocr20', 'v' + g.sys.game.mpConfig.version, 20, 1);
    g.versionText.setOrigin(0.5);

    g.tweenAssets = [ g.playButton, g.musicButton, g.sfxButton, g.versionText, g.musicButton.offState, g.sfxButton.offState, g.panel ];
    // g.tweenAssets = [ g.playButton, g.musicButton, g.sfxButton, g.musicButton.offState, g.sfxButton.offState, g.panel, g.title ];
    g.playButton.y -= 1000;
    g.musicButton.y -= 1000;
    g.sfxButton.y -= 1000;
    g.musicButton.offState.y -= 1000;
    g.sfxButton.offState.y -= 1000;
    g.versionText.y -= 1000;
    g.panel.y -= 1000;
    // g.title.y -= 1000;
    // g.open();
  }

  playButtonClicked () {
    let g = this;
    g.close();
  }

  toggleMusic () {
    soundManager.toggleMusic();
  }

  toggleSounds () {
    soundManager.toggleSounds();
  }

  open (duration = 250) {
    let g = this;
    g.info.isOpen = true;
    g.tweens.add({
      targets: [ g.greenBG ],
      y: config.CENTER_Y,
      // ease: 'Back.easeOut',
      duration: duration
    });
    g.tweens.add({
      targets: g.tweenAssets,
      y: '+=1000',
      // ease: 'Back.easeOut',
      ease: 'Back.easeOut',
      duration: duration,
      delay: duration
    });
  }

  close (duration = 250) {
    let g = this;
    g.info.isOpen = false;
    g.tweens.add({
      targets: [ g.greenBG ],
      y: g.endY,
      // ease: 'Back.easeOut',
      duration: duration,
      delay: duration,
      onComplete: g.closeComplete,
      onCompleteScope: this
    });
    g.tweens.add({
      targets: g.tweenAssets,
      y: '+=1000',
      // ease: 'Back.easeOut',
      duration: duration
    });
  }

  closeComplete () {
    let g = this;
    g.scene.stop(g.info.windowName);
    g.scene.resume(dataManager.getSessionItem(config.BASE_SCENE));
  }
}

export default BaseWindow;
